import Vue from 'vue'
import Router from 'vue-router'
import VueRouter from 'vue-router'
import store from '@/store/store'


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

let children = [ 
];

let pages = require('@/router/btoc');

children = children.concat(pages.default);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Layout',
      meta: {
        title: ''
        // login: true
      },
      component: () => import('@/components/Layout'),
      children: children
    }
  ]
})

router.beforeEach((to, from, next) => {
    let adminUser = store.getters['user/user'];

    if(!adminUser){
        let info = localStorage.getItem('web_user');
        if(info) {
            // 本地有用户信息。判断过期
            info = JSON.parse(info);
            store.dispatch('user/setUser', info);
            adminUser = info;
        }
    }

    if(to.matched.some(res => res.meta.login)){
        // 需要登录
        if(!adminUser){
            next({
                name: 'Login',
                query: {redirect: to.fullPath}
            })
        }else{
            next();
        }
    }else{
        next();
    }
})
// rotuer.beforeRouteUpdate(to,from,next){
//   this.cid=to.query.cid;
//   next();
// }

export default router



// WEBPACK FOOTER //
// ./src/router/index.js